export default function StoryHero() {
  return (
    <section id="story" className="relative w-full h-[360px] md:h-[520px] overflow-hidden bg-secondary-300">
      <img
        src="https://sofiajewelry.com/cdn/shop/files/sofia-jewelry-our-story-family-owned-jewelry_1500x.jpg?v=1614310783"
        alt="The Priolo family and the Sofia Jewelry store in Mill Valley"
        title="Sofia Jewelry — Our Story"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-foreground-950/25 to-foreground-950/10" />
      <div className="absolute inset-0 flex items-center justify-center">
        <header className="max-w-2xl mx-auto px-6 text-center">
          <h2 className="font-heading text-3xl md:text-5xl font-light tracking-[0.2em] uppercase text-background-50 mb-6">
            Sofia Jewelry
          </h2>
          <p className="font-body text-sm md:text-base text-background-100/90 leading-relaxed">
            At Sofia Jewelry, we believe that jewelry is meant to be worn and
            enjoyed for all of life's daily celebrations.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-x-8 gap-y-3 font-body text-xs md:text-sm text-background-100/85">
            <a
              href="https://www.google.com/maps/search/?api=1&query=80+Throckmorton+Ave+Mill+Valley+CA+94941-1918+United+States"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 hover:text-primary-300 transition-colors"
            >
              <i className="ri-map-pin-line text-primary-300" />
              80 Throckmorton Ave, Mill Valley, CA 94941
            </a>
            <a
              href="tel:+18174808824"
              className="inline-flex items-center gap-2 hover:text-primary-300 transition-colors"
            >
              <i className="ri-phone-line text-primary-300" />
              (817) 480-8824
            </a>
          </div>
          <a
            href="#contact"
            className="mt-8 inline-block border border-background-50/70 text-background-50 hover:bg-background-50 hover:text-foreground-950 font-label text-xs tracking-[0.24em] uppercase px-8 py-3.5 rounded-md transition-colors whitespace-nowrap"
          >
            Visit Our Store
          </a>
        </header>
      </div>
    </section>
  );
}